import React from "react";
import { Section } from "../components/SectionTitle";
import ConsultationForm from "../components/ConsultationForm";
import SEO from "../components/SEO";
import { CalendlyButton } from "../components/Calendly";
import { Phone, Mail, MapPin, Clock, Globe } from "lucide-react";
import { CONTACT } from "../lib/constants";

export default function Contact() {
  return (
    <div>
      <SEO
        title="Contact & Book a Consultation"
        description="Request a free consultation with HSA Service Hub. Reach our team for financial, tax, insurance, and legal service coordination across the United States."
        keywords="book consultation financial advisor, contact HSA Service Hub, tax consultation USA"
        path="/contact"
      />
      <section className="bg-[#0a2540] text-white py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="max-w-4xl">
            <div className="eyebrow text-[#d4af37] mb-3">Contact HSA Service Hub</div>
            <h1 className="font-serif-hsa text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.05] mb-5">
              Let's talk. We're here to help.
            </h1>
            <p className="text-lg text-white/85 max-w-2xl mb-8">
              Request a free consultation or reach out by phone or email. An HSA Service Hub advisor
              will respond within one business day.
            </p>
            <CalendlyButton dataTestId="contact-hero-calendly-btn">
              Schedule via Calendar
            </CalendlyButton>
          </div>
        </div>
      </section>

      <Section className="bg-white">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <h2 className="font-serif-hsa text-3xl font-semibold text-[#0a2540] mb-6">Contact Details</h2>
            <div className="space-y-5">
              {[
                { Icon: Phone, label: "Phone", value: CONTACT.phone },
                { Icon: Mail, label: "Email", value: CONTACT.email },
                { Icon: MapPin, label: "Office", value: CONTACT.address },
                { Icon: Clock, label: "Hours", value: CONTACT.hours },
                { Icon: Globe, label: "Service Area", value: "All 50 United States" },
              ].map(({ Icon, label, value }) => (
                <div key={label} className="flex items-start gap-4 border border-[#cbd5e1] rounded-xl p-5 bg-white lift-card">
                  <div className="w-10 h-10 rounded-lg bg-[#d4af37]/15 flex items-center justify-center text-[#d4af37] flex-shrink-0">
                    <Icon className="w-5 h-5" />
                  </div>
                  <div>
                    <div className="text-xs uppercase tracking-[0.15em] text-slate-500 font-semibold mb-0.5">{label}</div>
                    <div className="text-[#0a2540] font-medium">{value}</div>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-8 rounded-2xl overflow-hidden border border-[#cbd5e1] aspect-[5/3] bg-[#f8f9fa]">
              <iframe
                title="map"
                src="https://www.openstreetmap.org/export/embed.html?bbox=-74.02%2C40.74%2C-73.97%2C40.77&amp;layer=mapnik"
                className="w-full h-full"
                loading="lazy"
              />
            </div>
          </div>

          <div className="lg:col-span-7">
            <h2 className="font-serif-hsa text-3xl font-semibold text-[#0a2540] mb-6">Request a Consultation</h2>
            <ConsultationForm />
          </div>
        </div>
      </Section>
    </div>
  );
}
